import { get } from 'lodash';
import { PAYMENT_METHODS } from '@nandosaus/constants';
import { useCallback } from 'react';
import { useRootStore } from '@nandosaus/state-management';

import { buildConfig, payWithGooglePay } from '../../utils/google-pay';
import { logger } from '../../utils/logger';

const useGooglePay = ({ submitOrder }) => {
  const { CartStore, OrderStore, PaymentStore } = useRootStore();

  const createOrderWithGooglePay = useCallback(
    async (orderSummary, orderInput) => {
      const googlePayConfig = buildConfig({
        orderSummary,
        allowedCardNetworks: PaymentStore.availableCreditCardTypesForGooglePay,
      });

      let result;
      try {
        result = await payWithGooglePay(googlePayConfig);
      } catch (error) {
        logger.warn('error paying with google pay', error);
        OrderStore.handlePaymentError({ message: error.statusMessage });
      }

      const googlePayToken = get(result, 'paymentMethodData.tokenizationData.token');

      if (googlePayToken) {
        CartStore.payment.setAlternativePaymentMethod({
          type: PAYMENT_METHODS.GOOGLE_PAY,
          token: googlePayToken,
        });

        return submitOrder(orderInput);
      }
      return null;
    },
    [CartStore.payment, OrderStore, submitOrder, PaymentStore.availableCreditCardTypesForGooglePay]
  );

  return createOrderWithGooglePay;
};

export { useGooglePay };
